import React from 'react'

const Careers = () => {
  return (
    <div>
        <h1>Careers</h1>
    </div>
  )
}

export default Careers